// extracted by mini-css-extract-plugin
export const body = "ChartError-module__body--65xDE";
export const container = "ChartError-module__container--o5P35";
export const headline = "ChartError-module__headline--87G+d";